/* GermanyKG - Login-Icon winkt
   Standard-Account-Icon (nativ) + geknickter Winke-Arm links an der Schulter.
   Winkt 1,5s nach dem Laden und jedes Mal, wenn man wieder nach oben zum Header scrollt
   (nach dem Ankommen 1s Wartezeit). Blendet nach dem Winken aus.
   Account-Icon ist auf Mobil ohnehin ausgeblendet (small-hide). */
(function () {
  "use strict";
  var NS = "http://www.w3.org/2000/svg";
  var SPL5 = "0.4 0 0.2 1;0.4 0 0.2 1;0.4 0 0.2 1;0.4 0 0.2 1;0.4 0 0.2 1";
  var DUR = 1500; // Winkdauer in ms (passt zu dur="1.5s")

  // Groesserer, geknickter Arm; Linien etwas duenner (1.8). Drehpunkt Schulter (4.7,13.8).
  var ARM =
    '<path d="M4.7 13.8 L2 9.3 L4.4 2.7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>';
  // Winken (holt weit aus, -22 Grad); begin=indefinite -> per JS ausgeloest (mehrfach moeglich).
  var WAVE =
    '<animateTransform attributeName="transform" attributeType="XML" type="rotate" begin="indefinite" dur="1.5s" fill="freeze" calcMode="spline" ' +
      'keyTimes="0;0.15;0.35;0.55;0.75;1" keySplines="' + SPL5 + '" ' +
      'values="0 4.7 13.8;-22 4.7 13.8;12 4.7 13.8;-22 4.7 13.8;12 4.7 13.8;0 4.7 13.8"/>';

  function armSvg() {
    return '<svg xmlns="' + NS + '">' +
      '<g class="gkg-arm" opacity="0" style="transition:opacity .3s ease">' + ARM + WAVE + '</g>' +
      '</svg>';
  }

  function setup(svg, anchor) {
    var g = svg.querySelector(".gkg-arm");
    var anim = svg.querySelector("animateTransform");
    if (!g || !anim) return;
    var waving = false;
    function wave() {
      if (waving) return;
      waving = true;
      g.style.opacity = "1";
      try { anim.beginElement(); } catch (e) {}
      setTimeout(function () { g.style.opacity = "0"; }, DUR);
      setTimeout(function () { waving = false; }, DUR + 400);
    }
    // 1) einmal kurz nach dem Laden
    setTimeout(wave, 1500);
    // 2) erneut, wenn man wieder nach oben zum Header scrollt: nach Ankommen 1s warten, dann winken.
    if ("IntersectionObserver" in window) {
      var wasOut = false;
      var pending = null;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            if (wasOut && !pending) {
              pending = setTimeout(function () { pending = null; wave(); }, 1000);
            }
            wasOut = false;
          } else {
            wasOut = true;
            if (pending) { clearTimeout(pending); pending = null; } // vorher wieder runter -> abbrechen
          }
        }
      }, { threshold: 0.5 });
      io.observe(anchor);
    }
  }

  function enhance(anchor) {
    var svg = anchor.querySelector("svg.icon-account");
    if (!svg || svg.getAttribute("data-gkg-wave") === "1") return;
    svg.setAttribute("data-gkg-wave", "1");
    svg.setAttribute("overflow", "visible");
    try {
      var doc = new DOMParser().parseFromString(armSvg(), "image/svg+xml");
      var root = doc.documentElement;
      if (!root || (root.getElementsByTagName && root.getElementsByTagName("parsererror").length)) return;
      var kids = root.childNodes;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].nodeType === 1) svg.appendChild(document.importNode(kids[i], true));
      }
      setup(svg, anchor);
    } catch (e) { /* Icon bleibt unveraendert */ }
  }

  function init() {
    var links = document.querySelectorAll(".header__icon--account");
    for (var i = 0; i < links.length; i++) enhance(links[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
